export const LIVE_TV_PAGE_NAME = "LIVE";

export const LIVE_TV_REGIONS = {
    MEXICO: "MEX",
    USA: "USA",
    COSTA_RICA: "CRI",
} as const;

export const LIVE_TV_REGION_BY_INDEX: Record<number, string> = {
    0: LIVE_TV_REGIONS.MEXICO,
    1: LIVE_TV_REGIONS.USA,
    2: LIVE_TV_REGIONS.COSTA_RICA,
};

export const FAVORITES_CATEGORY_ID = 5000;
export const LIVE_FAVORITES_UPDATED_EVENT = "epic-live-favorites-updated";
